import { Component, OnInit,Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-show-dialog',
  templateUrl: './show-dialog.component.html',
  styleUrls: ['./show-dialog.component.css']
})
export class ShowDialogComponent implements OnInit {

	@Input() title;
	@Input() image;
	@Input() message;
	
	constructor(public activeModal: NgbActiveModal) { }

	ngOnInit() {
	}
	
	closeDialog(){
		
		this.activeModal.dismiss();
		
	}

}
